import React, { useState } from 'react';
import MultiForm from './MultiForm.js'
import FormExplanation from './FormExplanation.js'
import './App.css';
import loading_gif from './loader.gif';


const url = new URL(window.location.href);

const form_type = url.searchParams.get("action");
const lab_type = url.searchParams.get("lab_type");
const plan = url.searchParams.get("plan");
console.log(form_type);


// Laboratory types 
// search param: lab_type
// qc: control de calidad
// services: lims

// Form Types

// param: action 
// demo_request: demo_request


//samples
//Demo from Services LAB
// ?action=demo_request&lab_type=services

// Demo from QC Lab
// ?action=demo_request&lab_type=qc


//with plan
// ?action=free_trial_request&lab_type=services&plan=2




function ExplainedForm() {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(false);


    return (
        <>
            {loading &&
                <div className="loading">
                    <img className="img-fluid d-block mx-auto mb-3" src={loading_gif}
                        width="100" height="200" alt="Sending Request" />
                </div>
            }
            {message &&
             <div className="loading fade-in">
                 <div style={{maxWidth:'500px'}} className="form-container p-2 d-block mx-auto mb-3">

                    <h5 className="p-2">{message.title}</h5>

                    <p className="p-2">{message.body}</p>
                    <div className="text-right">
                    <button className="btn-action btn-md" onClick={(e)=>{setMessage(false)}}>Aceptar</button>
                    </div>
                     
                 </div>
             </div>
            
            }


            <div className="form-main-container">
                <div className="container">
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-lg-6">
                                <FormExplanation form_type={form_type} lab_type={lab_type} />
                            </div>
                            <div className="col-lg-6">
                                <MultiForm form_type={form_type} lab_type={lab_type} plan={plan} setLoading={setLoading} setMessage={setMessage} />
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </>

    );
}

export default ExplainedForm;
